module.exports = __webpack_public_path__ + "assets/img/11-l.f62c6a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/11-l.jpg
// module id = HnSn
// module chunks = 0